import { getEnvs } from "state/EnvironmentsContext/EnvContext";
import { fetchBase, FetchError, FetchSuccess } from "./managers";

export const getLastThemingUpdate = async () => {
  try {
    const domainName = getEnvs((state) => state.domain_name);
    const cloudinary_preset =
      getEnvs((state) => state.cloudinary_preset) ||
      getEnvs((state) => state.cloudinary_cloud_name);
    const res = await fetch(
      `https://res.cloudinary.com/${cloudinary_preset}/raw/upload/${domainName}/theming/latest_theming_time.json`,
      {
        cache: "no-store",
      },
    );

    if (!res.ok) throw res;
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res as Response);
  }
};

export const getOrganizationCustomData = async (eventId?: string) => {
  try {
    const res = await fetchBase(`user-dashboard/config`, null, {
      slugTarget: "url",
      eventId,
    });

    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res as Response);
  }
};
